import { GenderCode, INewMembershipInfo } from '@lib/types';
import { NewJoinSessionData, NewMembershipFormData } from '../application/models/NewJoinSessionData';

export const cache = {
  key: 'newjoinformdata',
  get: function (): NewJoinSessionData | undefined {
    const stringifiedCache = localStorage.getItem(this.key);
    return stringifiedCache ? JSON.parse(stringifiedCache) : undefined;
  },
  set: function (cache: NewJoinSessionData) {
    const { password: exclude1, confirmPassword: exclude2, ...cleanFormData } = cache.formData; // Cleans out password data
    const cleanCache = { ...cache, formData: { ...cleanFormData, password: null, confirmPassword: null } }; // Need to clean up data structure to not require password fields.
    localStorage.setItem(this.key, JSON.stringify(cleanCache));
  },
};

export const memberTempCache = {
  key: 'memberTempCache',
  set: function (cache: NewJoinSessionData) {
    const {
      residenceAddress,
      mailingAddress,
      mobileNumber,
      mobileConsent,
      firstName,
      lastName,
      dateOfBirth,
      email,
      gender,
    } = cache.formData;

    const form = {
      firstName,
      lastName,
      dateOfBirth,
      email,
      gender: gender !== GenderCode.X ? gender : null,
      mobileNumber,
      mobileConsent,
      residenceAddress,
      mailingAddress,
    };

    sessionStorage.setItem(this.key, JSON.stringify(form));
  },
  get: function (): Partial<NewMembershipFormData> {
    const formString = sessionStorage.getItem(this.key);
    if (formString) {
      return JSON.parse(formString);
    }
    return {} as NewMembershipFormData;
  },
  delete: function () {
    sessionStorage.removeItem(this.key);
  },
};

export const membershipInfoCache = {
  key: 'membershipInfoCache',
  set: function (membershipInfo: INewMembershipInfo) {
    sessionStorage.setItem(this.key, JSON.stringify(membershipInfo));
  },
  get: function (): INewMembershipInfo | undefined {
    const stubs = !(process.env.NODE_ENV === 'production' || process.env.REACT_APP_SOURCES === 'remote');
    const objStr = sessionStorage.getItem(this.key);
    if (objStr && !stubs) {
      return JSON.parse(objStr);
    }
  },
  delete: function () {
    sessionStorage.removeItem(this.key);
  },
};
